import { c as _c } from "react/compiler-runtime";
import React, { MouseEventHandler, useCallback, useState } from 'react';
import { DropdownList } from '../../dropdown/DropdownList/DropdownList';
import { DropdownPopper, DropdownPopperProps } from '../../dropdown/DropdownPopper/DropdownPopper';
import { IconDeprecated, IconSize, IconType } from '../../misc/IconDeprecated/IconDeprecated';
import { prepareProps } from '../../utils/propUtils';
import { ButtonStandard, ButtonStandardProps } from '../ButtonStandard/ButtonStandard';
import styles from './DropdownButton.module.css';
export type DropdownButtonProps<T> = ButtonStandardProps & {
  readonly items: Array<T>;
  readonly getDisplayTextOfItem: (item: T) => string;
  readonly getKeyOfItem: (item: T, index: number) => string;
  /**
   * the item will be null if no items are provided
   */
  readonly onItemSelected: (item: T | null) => void;
};
export const DropdownButton = React.memo(props => {
  const $ = _c(31);
  let t0;
  if ($[0] !== props) {
    t0 = prepareProps({
      props
    });
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let children;
  let getDisplayTextOfItem;
  let getKeyOfItem;
  let items;
  let onClick;
  let onItemSelected;
  let remainingProps;
  if ($[2] !== t0) {
    ({
      items,
      getDisplayTextOfItem,
      getKeyOfItem,
      onItemSelected,
      onClick,
      children,
      ...remainingProps
    } = t0);
    $[2] = t0;
    $[3] = children;
    $[4] = getDisplayTextOfItem;
    $[5] = getKeyOfItem;
    $[6] = items;
    $[7] = onClick;
    $[8] = onItemSelected;
    $[9] = remainingProps;
  } else {
    children = $[3];
    getDisplayTextOfItem = $[4];
    getKeyOfItem = $[5];
    items = $[6];
    onClick = $[7];
    onItemSelected = $[8];
    remainingProps = $[9];
  }
  const [displayItems, setDisplayItems] = useState(false);
  let t1;
  if ($[10] !== onItemSelected) {
    t1 = item => {
      setDisplayItems(false);
      onItemSelected(item);
    };
    $[10] = onItemSelected;
    $[11] = t1;
  } else {
    t1 = $[11];
  }
  const handleItemSelected = t1;
  let t2;
  if ($[12] !== handleItemSelected || $[13] !== items[0] || $[14] !== items.length || $[15] !== onClick) {
    t2 = event => {
      onClick?.(event);
      if (event.defaultPrevented) {
        return;
      }
      const firstItem = items[0];
      if (items.length > 1) {
        setDisplayItems(true);
      } else {
        if (firstItem) {
          handleItemSelected(firstItem);
        } else {
          handleItemSelected(null);
        }
      }
    };
    $[12] = handleItemSelected;
    $[13] = items[0];
    $[14] = items.length;
    $[15] = onClick;
    $[16] = t2;
  } else {
    t2 = $[16];
  }
  const handleButtonClick = t2;
  let t3;
  if ($[17] !== getDisplayTextOfItem || $[18] !== getKeyOfItem || $[19] !== handleItemSelected || $[20] !== items) {
    t3 = t4 => {
      const {
        ref
      } = t4;
      return <DropdownList ref={ref} items={items} getKeyOfItem={getKeyOfItem} getDisplayTextOfItem={getDisplayTextOfItem} onItemSelected={handleItemSelected} data-testid="DropdownButton.DropdownList" />;
    };
    $[17] = getDisplayTextOfItem;
    $[18] = getKeyOfItem;
    $[19] = handleItemSelected;
    $[20] = items;
    $[21] = t3;
  } else {
    t3 = $[21];
  }
  const renderContent = t3;
  let t4;
  if ($[22] !== children || $[23] !== handleButtonClick || $[24] !== items.length || $[25] !== remainingProps) {
    t4 = t5 => {
      const {
        ref: ref_0
      } = t5;
      return <ButtonStandard ref={ref_0} data-testid="DropdownButton.Button" {...remainingProps} onClick={handleButtonClick}>{children}{items.length > 1 ? <IconDeprecated type={IconType.Solid} name="caret-down" size={IconSize.Small} className={styles.icon} data-testid="DropdownButton.Icon" /> : undefined}</ButtonStandard>;
    };
    $[22] = children;
    $[23] = handleButtonClick;
    $[24] = items.length;
    $[25] = remainingProps;
    $[26] = t4;
  } else {
    t4 = $[26];
  }
  let t5;
  if ($[27] !== displayItems || $[28] !== renderContent || $[29] !== t4) {
    t5 = <DropdownPopper visible={displayItems} renderContent={renderContent} setVisible={setDisplayItems} hideOnOutsideClick={true}>{t4}</DropdownPopper>;
    $[27] = displayItems;
    $[28] = renderContent;
    $[29] = t4;
    $[30] = t5;
  } else {
    t5 = $[30];
  }
  return t5;
}) as <T>(props: DropdownButtonProps<T>) => React.JSX.Element;